import {
  Create,
  Grid,
  Typography,
  SaveButton,
  Hidden,
  TextField,
} from "@pankod/refine-mui";

import AutoGeneratedInputCmp from "components/auto-generated-input/AutoGeneratedInputCmp";

import { useForm } from "@pankod/refine-react-hook-form";
import { Link } from "@pankod/refine-react-router-v6";
import { useNavigate } from "@pankod/refine-react-router-v6";

// base fields
const fields = [
  {
    label: "Full Name",
    name: "full_name",
    required: true,
    type: "text",
    md: 6,
  },
  {
    label: "Email",
    name: "email",
    required: true,
    type: "text",
    md: 6,
  },
  {
    label: "Phone",
    name: "phone",
    required: true,
    type: "number",
    md: 6,
  },
  {
    type: "divider",
  },
  {
    label: "Company Name",
    name: "business_name",
    required: true,
    type: "text",
    md: 12,
  },
  {
    label: "Company Registration Number / UTR",
    name: "vat",
    required: true,
    type: "text",
    md: 12,
  },
  {
    label: "Company Address",
    name: "address",
    required: true,
    type: "text",
    md: 12,
  },
  {
    label: "Post Code",
    name: "zip_code",
    required: true,
    type: "text",
    md: 6,
  },
  {
    type: "divider",
  },
  {
    label: "Message",
    name: "message",
    required: true,
    type: "text",
    md: 12,
    lines: 8,
  },
];

export default function UserRegistration() {
  const {
    refineCore: { formLoading, onFinish },
    register,
    control,
    formState: { errors },
    getValues,
    setValue,
    setError,
    handleSubmit,
    watch,
  } = useForm();

  // const [isTosSelected, setIsTosSelected] = useState(false);
  const navigate = useNavigate();

  return (
    <Grid container style={{ backgroundColor: "#e4e4e4" }}>
      <Grid
        item
        xs={12}
        container
        justifyContent="center"
        alignItems="flex-start"
        sx={{ mx: 30, my: 10 }}
      >
        <Grid item xs={12} container alignItems="center" direction="column">
          <Link to={`/`} style={{ textDecoration: "none" }}>
            <img
              src="/logo.png"
              alt="Logo"
              style={{ height: 80, objectFit: "contain" }}
            />
          </Link>

          <Typography mt={6} mb={2} variant="h4">
            Request Access to Outreacher
          </Typography>
        </Grid>
        <Create
          isLoading={formLoading}
          footerButtons={() => null}
          goBack={false}
          title=""
          wrapperProps={{
            sx: {
              borderRadius: 8,
            },
          }}
        >
          <Grid container spacing={2} style={{ padding: "30px" }}>
            {fields.map((field, index) => {
              return (
                <AutoGeneratedInputCmp
                  key={index}
                  {...field}
                  register={register}
                  control={control}
                  errors={errors}
                  setError={setError}
                  defaultValue={watch(field.name)}
                  getValues={getValues}
                  setValue={setValue}
                  watch={watch}
                />
              );
            })}
            <Hidden>
              <TextField
                {...register("status")}
                hidden
                required={true}
                defaultValue="pending"
                type="text"
                style={{ height: "0", display: "none" }}
              />
            </Hidden>
            {/* <Grid
              container
              spacing={2}
              style={{ padding: "30px" }}
              justifyContent="start"
              gap={1}
              alignItems="center"
              >
              <Checkbox
              checked={isTosSelected}
              onChange={() => setIsTosSelected((sel) => !sel)}
              />
              <Typography variant="body2">accetto le condizioni</Typography>
            </Grid> */}
          </Grid>
        </Create>
        <Grid container justifyContent="center" mt={5}>
          <SaveButton
            svgIconProps={{
              sx: {
                display: "none",
              },
            }}
            onClick={async () => {
              try {
                await handleSubmit(onFinish)();
                // go to home
                navigate("/");
              } catch (error) {
                console.log(error);
              }
            }}
            // disabled={!isTosSelected}
          >
            REQUEST ACCESS
          </SaveButton>
        </Grid>
      </Grid>
    </Grid>
  );
}
